// source: wt/svc/shared/shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.wt_srv_shared.Address', null, global);
goog.exportSymbol('proto.wt_srv_shared.Authority', null, global);
goog.exportSymbol('proto.wt_srv_shared.Connector', null, global);
goog.exportSymbol('proto.wt_srv_shared.ConnectorAccessToken', null, global);
goog.exportSymbol('proto.wt_srv_shared.ConnectorAuthType', null, global);
goog.exportSymbol('proto.wt_srv_shared.ConnectorHeartbeatStatus', null, global);
goog.exportSymbol('proto.wt_srv_shared.ConnectorType', null, global);
goog.exportSymbol('proto.wt_srv_shared.Currency', null, global);
goog.exportSymbol('proto.wt_srv_shared.EmptyMsg', null, global);
goog.exportSymbol('proto.wt_srv_shared.GenericResult', null, global);
goog.exportSymbol('proto.wt_srv_shared.GenericResultMessage', null, global);
goog.exportSymbol('proto.wt_srv_shared.ManagementSystemType', null, global);
goog.exportSymbol('proto.wt_srv_shared.PlanCycle', null, global);
goog.exportSymbol('proto.wt_srv_shared.ReceivePostedTimeStatus', null, global);
goog.exportSymbol('proto.wt_srv_shared.SubscriberState', null, global);
goog.exportSymbol('proto.wt_srv_shared.TeamIdMsg', null, global);
goog.exportSymbol('proto.wt_srv_shared.TeamType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wt_srv_shared.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wt_srv_shared.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wt_srv_shared.Address.displayName = 'proto.wt_srv_shared.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wt_srv_shared.TeamIdMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wt_srv_shared.TeamIdMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wt_srv_shared.TeamIdMsg.displayName = 'proto.wt_srv_shared.TeamIdMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wt_srv_shared.GenericResultMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wt_srv_shared.GenericResultMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wt_srv_shared.GenericResultMessage.displayName = 'proto.wt_srv_shared.GenericResultMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wt_srv_shared.EmptyMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wt_srv_shared.EmptyMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wt_srv_shared.EmptyMsg.displayName = 'proto.wt_srv_shared.EmptyMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wt_srv_shared.Connector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wt_srv_shared.Connector.repeatedFields_, null);
};
goog.inherits(proto.wt_srv_shared.Connector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wt_srv_shared.Connector.displayName = 'proto.wt_srv_shared.Connector';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wt_srv_shared.ConnectorAccessToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wt_srv_shared.ConnectorAccessToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wt_srv_shared.ConnectorAccessToken.displayName = 'proto.wt_srv_shared.ConnectorAccessToken';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wt_srv_shared.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.wt_srv_shared.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wt_srv_shared.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    addressLine1: jspb.Message.getFieldWithDefault(msg, 2, ""),
    addressLine2: jspb.Message.getFieldWithDefault(msg, 7, ""),
    postalCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    state: jspb.Message.getFieldWithDefault(msg, 4, ""),
    city: jspb.Message.getFieldWithDefault(msg, 5, ""),
    countryCode: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wt_srv_shared.Address}
 */
proto.wt_srv_shared.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wt_srv_shared.Address;
  return proto.wt_srv_shared.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wt_srv_shared.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wt_srv_shared.Address}
 */
proto.wt_srv_shared.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressLine1(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressLine2(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wt_srv_shared.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wt_srv_shared.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wt_srv_shared.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddressLine1();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddressLine2();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPostalCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.wt_srv_shared.Address.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Address} returns this
 */
proto.wt_srv_shared.Address.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address_line_1 = 2;
 * @return {string}
 */
proto.wt_srv_shared.Address.prototype.getAddressLine1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Address} returns this
 */
proto.wt_srv_shared.Address.prototype.setAddressLine1 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address_line_2 = 7;
 * @return {string}
 */
proto.wt_srv_shared.Address.prototype.getAddressLine2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Address} returns this
 */
proto.wt_srv_shared.Address.prototype.setAddressLine2 = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string postal_code = 3;
 * @return {string}
 */
proto.wt_srv_shared.Address.prototype.getPostalCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Address} returns this
 */
proto.wt_srv_shared.Address.prototype.setPostalCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string state = 4;
 * @return {string}
 */
proto.wt_srv_shared.Address.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Address} returns this
 */
proto.wt_srv_shared.Address.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.wt_srv_shared.Address.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Address} returns this
 */
proto.wt_srv_shared.Address.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string country_code = 6;
 * @return {string}
 */
proto.wt_srv_shared.Address.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Address} returns this
 */
proto.wt_srv_shared.Address.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wt_srv_shared.TeamIdMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.wt_srv_shared.TeamIdMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wt_srv_shared.TeamIdMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.TeamIdMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wt_srv_shared.TeamIdMsg}
 */
proto.wt_srv_shared.TeamIdMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wt_srv_shared.TeamIdMsg;
  return proto.wt_srv_shared.TeamIdMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wt_srv_shared.TeamIdMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wt_srv_shared.TeamIdMsg}
 */
proto.wt_srv_shared.TeamIdMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wt_srv_shared.TeamIdMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wt_srv_shared.TeamIdMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wt_srv_shared.TeamIdMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.TeamIdMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.wt_srv_shared.TeamIdMsg.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.TeamIdMsg} returns this
 */
proto.wt_srv_shared.TeamIdMsg.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wt_srv_shared.GenericResultMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.wt_srv_shared.GenericResultMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wt_srv_shared.GenericResultMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.GenericResultMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wt_srv_shared.GenericResultMessage}
 */
proto.wt_srv_shared.GenericResultMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wt_srv_shared.GenericResultMessage;
  return proto.wt_srv_shared.GenericResultMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wt_srv_shared.GenericResultMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wt_srv_shared.GenericResultMessage}
 */
proto.wt_srv_shared.GenericResultMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.wt_srv_shared.GenericResult} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wt_srv_shared.GenericResultMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wt_srv_shared.GenericResultMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wt_srv_shared.GenericResultMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.GenericResultMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional GenericResult status = 1;
 * @return {!proto.wt_srv_shared.GenericResult}
 */
proto.wt_srv_shared.GenericResultMessage.prototype.getStatus = function() {
  return /** @type {!proto.wt_srv_shared.GenericResult} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.wt_srv_shared.GenericResult} value
 * @return {!proto.wt_srv_shared.GenericResultMessage} returns this
 */
proto.wt_srv_shared.GenericResultMessage.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.wt_srv_shared.GenericResultMessage.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.GenericResultMessage} returns this
 */
proto.wt_srv_shared.GenericResultMessage.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wt_srv_shared.EmptyMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.wt_srv_shared.EmptyMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wt_srv_shared.EmptyMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.EmptyMsg.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wt_srv_shared.EmptyMsg}
 */
proto.wt_srv_shared.EmptyMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wt_srv_shared.EmptyMsg;
  return proto.wt_srv_shared.EmptyMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wt_srv_shared.EmptyMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wt_srv_shared.EmptyMsg}
 */
proto.wt_srv_shared.EmptyMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wt_srv_shared.EmptyMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wt_srv_shared.EmptyMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wt_srv_shared.EmptyMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.EmptyMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wt_srv_shared.Connector.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wt_srv_shared.Connector.prototype.toObject = function(opt_includeInstance) {
  return proto.wt_srv_shared.Connector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wt_srv_shared.Connector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.Connector.toObject = function(includeInstance, msg) {
  var f, obj = {
    connectorName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    apiKeysList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    receivePostedTime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    connectorLabel: jspb.Message.getFieldWithDefault(msg, 5, ""),
    teamId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    heartbeatstatus: jspb.Message.getFieldWithDefault(msg, 7, 0),
    connectorAuthType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    externalSystemType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    managementSystemType: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wt_srv_shared.Connector}
 */
proto.wt_srv_shared.Connector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wt_srv_shared.Connector;
  return proto.wt_srv_shared.Connector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wt_srv_shared.Connector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wt_srv_shared.Connector}
 */
proto.wt_srv_shared.Connector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectorName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addApiKeys(value);
      break;
    case 4:
      var value = /** @type {!proto.wt_srv_shared.ReceivePostedTimeStatus} */ (reader.readEnum());
      msg.setReceivePostedTime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectorLabel(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 7:
      var value = /** @type {!proto.wt_srv_shared.ConnectorHeartbeatStatus} */ (reader.readEnum());
      msg.setHeartbeatstatus(value);
      break;
    case 9:
      var value = /** @type {!proto.wt_srv_shared.ConnectorAuthType} */ (reader.readEnum());
      msg.setConnectorAuthType(value);
      break;
    case 10:
      var value = /** @type {!proto.wt_srv_shared.ConnectorType} */ (reader.readEnum());
      msg.setExternalSystemType(value);
      break;
    case 11:
      var value = /** @type {!proto.wt_srv_shared.ManagementSystemType} */ (reader.readEnum());
      msg.setManagementSystemType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wt_srv_shared.Connector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wt_srv_shared.Connector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wt_srv_shared.Connector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.Connector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConnectorName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApiKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getReceivePostedTime();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getConnectorLabel();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getHeartbeatstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getConnectorAuthType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getExternalSystemType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getManagementSystemType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
};


/**
 * optional string connector_name = 1;
 * @return {string}
 */
proto.wt_srv_shared.Connector.prototype.getConnectorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setConnectorName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string api_keys = 2;
 * @return {!Array<string>}
 */
proto.wt_srv_shared.Connector.prototype.getApiKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setApiKeysList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.addApiKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.clearApiKeysList = function() {
  return this.setApiKeysList([]);
};


/**
 * optional ReceivePostedTimeStatus receive_posted_time = 4;
 * @return {!proto.wt_srv_shared.ReceivePostedTimeStatus}
 */
proto.wt_srv_shared.Connector.prototype.getReceivePostedTime = function() {
  return /** @type {!proto.wt_srv_shared.ReceivePostedTimeStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.wt_srv_shared.ReceivePostedTimeStatus} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setReceivePostedTime = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string connector_label = 5;
 * @return {string}
 */
proto.wt_srv_shared.Connector.prototype.getConnectorLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setConnectorLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string team_id = 6;
 * @return {string}
 */
proto.wt_srv_shared.Connector.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ConnectorHeartbeatStatus heartbeatStatus = 7;
 * @return {!proto.wt_srv_shared.ConnectorHeartbeatStatus}
 */
proto.wt_srv_shared.Connector.prototype.getHeartbeatstatus = function() {
  return /** @type {!proto.wt_srv_shared.ConnectorHeartbeatStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.wt_srv_shared.ConnectorHeartbeatStatus} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setHeartbeatstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional ConnectorAuthType connector_auth_type = 9;
 * @return {!proto.wt_srv_shared.ConnectorAuthType}
 */
proto.wt_srv_shared.Connector.prototype.getConnectorAuthType = function() {
  return /** @type {!proto.wt_srv_shared.ConnectorAuthType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.wt_srv_shared.ConnectorAuthType} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setConnectorAuthType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional ConnectorType external_system_type = 10;
 * @return {!proto.wt_srv_shared.ConnectorType}
 */
proto.wt_srv_shared.Connector.prototype.getExternalSystemType = function() {
  return /** @type {!proto.wt_srv_shared.ConnectorType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.wt_srv_shared.ConnectorType} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setExternalSystemType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional ManagementSystemType management_system_type = 11;
 * @return {!proto.wt_srv_shared.ManagementSystemType}
 */
proto.wt_srv_shared.Connector.prototype.getManagementSystemType = function() {
  return /** @type {!proto.wt_srv_shared.ManagementSystemType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.wt_srv_shared.ManagementSystemType} value
 * @return {!proto.wt_srv_shared.Connector} returns this
 */
proto.wt_srv_shared.Connector.prototype.setManagementSystemType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.toObject = function(opt_includeInstance) {
  return proto.wt_srv_shared.ConnectorAccessToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wt_srv_shared.ConnectorAccessToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.ConnectorAccessToken.toObject = function(includeInstance, msg) {
  var f, obj = {
    externalAccessToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expiryTime: (f = msg.getExpiryTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wt_srv_shared.ConnectorAccessToken}
 */
proto.wt_srv_shared.ConnectorAccessToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wt_srv_shared.ConnectorAccessToken;
  return proto.wt_srv_shared.ConnectorAccessToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wt_srv_shared.ConnectorAccessToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wt_srv_shared.ConnectorAccessToken}
 */
proto.wt_srv_shared.ConnectorAccessToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalAccessToken(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiryTime(value);
      break;
    case 3:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wt_srv_shared.ConnectorAccessToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wt_srv_shared.ConnectorAccessToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wt_srv_shared.ConnectorAccessToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExternalAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpiryTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string external_access_token = 1;
 * @return {string}
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.getExternalAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wt_srv_shared.ConnectorAccessToken} returns this
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.setExternalAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp expiry_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.getExpiryTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.wt_srv_shared.ConnectorAccessToken} returns this
*/
proto.wt_srv_shared.ConnectorAccessToken.prototype.setExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wt_srv_shared.ConnectorAccessToken} returns this
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.clearExpiryTime = function() {
  return this.setExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.hasExpiryTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * map<string, string> metadata = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.wt_srv_shared.ConnectorAccessToken} returns this
 */
proto.wt_srv_shared.ConnectorAccessToken.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};


/**
 * @enum {number}
 */
proto.wt_srv_shared.Currency = {
  CURRENCY_UNSPECIFIED: 0,
  AUD: 1,
  EUR: 2,
  USD: 3,
  GBP: 4
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.TeamType = {
  TEAM_TYPE_UNSPECIFIED: 0,
  STARTER: 1,
  PROFESSIONAL: 2,
  ENTERPRISE: 3
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.PlanCycle = {
  PLAN_CYCLE_UNSPECIFIED: 0,
  MONTHLY: 1,
  QUARTERLY: 2,
  HALF_YEARLY: 4,
  YEARLY: 3
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.GenericResult = {
  GENERIC_RESULT_UNSPECIFIED: 0,
  RESULT_FAILED: 1,
  RESULT_SUCCESS: 2,
  RESULT_SKIPPED: 3
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.ConnectorHeartbeatStatus = {
  ALARM_STATUS_UNSPECIFIED: 0,
  OK: 1,
  ALARM: 2
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.ConnectorType = {
  CONNECTOR_TYPE_UNSPECIFIED: 0,
  CLIO: 1,
  INPROTECH: 2,
  INSIGHTLY: 3,
  INTERASCO_EFILIA: 4,
  JIRA: 5,
  PATRICIA: 6,
  PATRAWIN: 7,
  JIRA_CLOUD: 8,
  PRACTICE_PANTHER: 10,
  ROCKET_MATTER: 11,
  QUICKBOOKS: 12,
  MITRATECH: 13,
  LAWCUS: 14,
  ACTIONSTEP: 15,
  DYNAMICS_365_BUSINESS_CENTRAL_ON_PREM: 16,
  DYNAMICS_365_BUSINESS_CENTRAL_CLOUD: 18,
  SQL: 17,
  OTHER: 9
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.ConnectorAuthType = {
  CONNECTOR_AUTH_TYPE_UNSPECIFIED: 0,
  SINGLE_ADMIN_TOKEN: 1,
  PER_USER_TOKEN: 2
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.ReceivePostedTimeStatus = {
  DISABLED: 0,
  WEBHOOK: 1,
  LONG_POLL: 2
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.SubscriberState = {
  SUBSCRIBER_STATE_UNSPECIFIED: 0,
  ACTIVE: 1,
  RESTRICTED: 2,
  TRASHED: 3
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.ManagementSystemType = {
  MANAGEMENT_SYSTEM_TYPE_UNSPECIFIED: 0,
  MS_ABACUS_LAW: 1,
  MS_ACTIONSTEP: 46,
  MS_ADERANT: 34,
  MS_ALLISA: 37,
  MS_AMBERLO: 47,
  MS_ANAQUA: 2,
  MS_ANNO_TEXT: 3,
  MS_APIGES: 4,
  MS_BILL4TIME: 5,
  MS_CASEFOX: 48,
  MS_CLIO: 6,
  MS_CLIO_EU: 35,
  MS_COSMOLEX: 7,
  MS_DYNAMICS_365_BUSINESS_CENTRAL_CLOUD: 44,
  MS_DYNAMICS_365_BUSINESS_CENTRAL_ON_PREM: 45,
  MS_ELITE: 8,
  MS_EFILIA_IP: 39,
  MS_EQUINOX: 9,
  MS_EXPERT: 10,
  MS_FILEVINE: 49,
  MS_FOUNDATION_IP: 11,
  MS_GENESE: 12,
  MS_HIGHQ: 50,
  MS_INPROTECH: 13,
  MS_INSIGHTLY: 38,
  MS_ITIMEKEEP: 51,
  MS_JIRA: 14,
  MS_JIRA_CLOUD: 15,
  MS_JURIS: 33,
  MS_LAWCUS: 43,
  MS_LAWGRO: 52,
  MS_LEAP: 16,
  MS_LEXISNEXIS: 53,
  MS_LITIFY: 54,
  MS_MERUSCASE: 55,
  MS_MITRATECH: 42,
  MS_MYCASE: 56,
  MS_MYOB: 17,
  MS_NEBULAW: 57,
  MS_NOT_APPLICABLE: 36,
  MS_ORION: 18,
  MS_OTHER: 19,
  MS_PATORG: 20,
  MS_PATRAWIN: 21,
  MS_PATRICIA: 22,
  MS_PATTSYWAVE: 58,
  MS_PCLAW: 23,
  MS_PERFECTLAW: 59,
  MS_PRACTICE_PANTHER: 40,
  MS_ROCKET_MATTER: 41,
  MS_PRACTICE_PARTNER: 24,
  MS_PROLAW: 25,
  MS_QUICKBOOKS: 26,
  MS_RIPPE_KINGSTON: 27,
  MS_SIMPLELAW: 60,
  MS_SMOKEBALL: 61,
  MS_SPINELEGAL: 62,
  MS_SUREPOINT_TECHNOLOGIES: 63,
  MS_TABS3: 28,
  MS_TIMESLIPS: 64,
  MS_TIMESOLV: 29,
  MS_WINPAT: 30,
  MS_XERO: 31,
  MS_ZOLA_SUITE: 32
};

/**
 * @enum {number}
 */
proto.wt_srv_shared.Authority = {
  AUTHORITY_UNSPECIFIED: 0,
  MEMBER: 1,
  USER_ADMIN: 5,
  MANAGER: 2,
  OWNER: 3,
  SYSADMIN: 4
};

goog.object.extend(exports, proto.wt_srv_shared);
